export default "__VITE_ASSET__xbEjq8MG__"